import { render, staticRenderFns } from "./imageDetails.vue?vue&type=template&id=2627f51c&"
import script from "./imageDetails.vue?vue&type=script&lang=js&"
export * from "./imageDetails.vue?vue&type=script&lang=js&"
import style0 from "./imageDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports